var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOndefy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#31B5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 22C14 23 16 24 18 24C20.5 24 23 23.5 23 21C23 18.5 20.5495 18 18 18C15.5 18 13 17.5 13 15C13 12.5 15.5 12 18 12C20 12 22 13 23 14M18 9V27",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOndefy);
export default __webpack_public_path__ + "static/media/Ondefy.ef19feae6f16d65f66ad1a87664bc640.svg";
export { ForwardRef as ReactComponent };